import {
  Component,
  HostBinding,
  Input,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MessageType } from "./message.type";

@Component({
  selector: "app-message-box",
  templateUrl: "./message-box.component.html",
  styleUrls: ["./message-box.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MessageBoxComponent {
  /**
   * Text that gets displayed in the message box
   */
  @Input() message: string = "";

  /**
   * Depending on Message Type the marker gets its colour
   */
  @Input() messageType: MessageType = MessageType.Error;

  /** ⚠ Kein `box`: das ist die Karten-Klasse der antippbaren Kacheln. */
  @HostBinding("class") get hostClasses() {
    return ["message-box", `message-box--${this.messageType}`];
  }

  /** Ein Fehler unterbricht, ein Hinweis wartet auf die naechste Pause. */
  @HostBinding("attr.role") get role(): string {
    return this.messageType === MessageType.Error ? "alert" : "status";
  }
}
